// Loading spinner component
export default function Spinner() {
    return (
        <div className="my-10 mx-auto block w-fit">
            <div className="border-t-transparent border-solid animate-spin rounded-full border-primary-400 border-4 h-14 w-14"></div>
        </div>
    )
}